import axios from '@/util/basehttp';
import qs from 'qs';


const pre = "/teacher/resourcePoint"

const resourcePoint = {
  resourcePointTreePage(pageSize, limit, keyWord, subjectId, sortType) {
    return axios.get(pre + `/resourcePointTreePage`, {
      params:
        {
          pageSize: pageSize,
          limit: limit,
          keyWord: keyWord,
          subjectId: subjectId,
          sortType: sortType
        }
    });
  },
  resourcePointTreeListAll(subjectId, sortType) {
    return axios.get(pre + `/resourcePointTreeListAll`, {
      params:
        {
          subjectId: subjectId,
          sortType: sortType
        }
    });
  },

  resourcePointInfo(id) {
    return axios.get(pre + `/resourcePointInfo`, {params: {id: id}});
  },
  saveResourcePoint(params) {
    return axios.post(pre + `/saveResourcePoint`, qs.stringify(params));
  },
  resourcePointDelete(id) {
    return axios.delete(pre + `/resourcePointDelete`, {params: {id: id}});
  },
}
export default resourcePoint;



// WEBPACK FOOTER //
// ./src/api/teacher/resourcePoint.js